module.exports = __webpack_public_path__ + "static/media/assignment-black-18dp.c5540b8c.svg";